import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import * as _ from 'lodash';
import {UsersReportsService as UsersReportsV2ApiService} from '../../api/services/users-reports.service';
import {ExportUsersSummaryRequest} from '../../api/models/export-users-summary-request';
import {NotificationService} from '../../notification/notification.service';

@Injectable()
export class UsersSummaryV2Service {

  public exportColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'totalCount', title: 'Total Calls', width: 10},

    {id: _.uniqueId('id_'), field: 'totalOutgoingCount', title: 'Outgoing Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalOutgoingAnswered', title: 'Outgoing Answered', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalOutgoingMissed', title: 'Outgoing Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalIncomingCount', title: 'Incoming Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingAnswered', title: 'Incoming Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingMailbox', title: 'Incoming Mailbox', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingMissed', title: 'Incoming Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalInternalCount', title: 'Internal Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalAnswered', title: 'Internal Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalMailbox', title: 'Internal Mailbox', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalMissed', title: 'Internal Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalTalkDurationFormatted', title: 'Total Talk Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgTalkDurationFormatted', title: 'Avg. Talk Time', width: 10},
    {id: _.uniqueId('id_'), field: 'totalRingDurationFormatted', title: 'Total Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgRingDurationFormatted', title: 'Avg. Ring Time', width: 10},
  ];

  constructor(private authService: AuthService,
              private reportsApiService: UsersReportsV2ApiService,
              private notificationsService: NotificationService) {
  }

  public async exportLogs(state: ExportUsersSummaryRequest): Promise<void> {
    console.log(state);

    await this.reportsApiService.usersSummaryV2GetExport({body: state}).toPromise();
    this.notificationsService.notifySuccess('Export is in progress. You will get notification then download is finished.');
    return;
  }
}
